module.exports = __webpack_public_path__ + "img/landshut_gemaelde.3fc56b49.jpg";